export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-480-f5b94ecdbcdc3eb24cca8ed47fa0947d.png";